document.addEventListener('DOMContentLoaded', function() {
    function isMobile() {
        return window.innerWidth <= 768;
    }

    const categoryLinks = document.querySelectorAll('.category-list a');
    categoryLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            document.querySelectorAll('.info-section').forEach(section => {
                section.style.display = 'none';
            });
            const targetId = this.getAttribute('data-target');
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                targetSection.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        targetSection.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            if (targetId === 'wifi-info') {
                document.querySelectorAll('#wifiResetContent > div').forEach(content => {
                    content.style.display = 'none';
                });
                document.getElementById('defaultContent').style.display = 'block';
            }
            if (targetId === 'doorbell-info') {
                document.querySelectorAll('#doorbellResetContent > div').forEach(content => {
                    content.style.display = 'none';
                });
                document.getElementById('doorbellDefaultContent').style.display = 'block';
            }
            if (targetId === 'floodlight-info') {
                document.querySelectorAll('#floodlightResetContent > div').forEach(content => {
                    content.style.display = 'none';
                });
                document.getElementById('floodlightDefaultContent').style.display = 'block';
            }
            if (targetId === 'ip-info') {
                document.querySelectorAll('#ipResetContent > div').forEach(content => {
                    content.style.display = 'none';
                });
                document.getElementById('ipDefaultContent').style.display = 'block';
            }
            if (targetId === 'battery-info') {
                document.querySelectorAll('#batteryResetContent > div').forEach(content => {
                    content.style.display = 'none';
                });
                document.getElementById('batteryDefaultContent').style.display = 'block';
            }
        });
    });

    const wifiOptionsLinks = document.querySelectorAll('.wifi-options a');
    wifiOptionsLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const wifiSection = document.getElementById('wifi-info');
            if (wifiSection) {
                wifiSection.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        wifiSection.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            document.querySelectorAll('#wifiResetContent > div').forEach(content => {
                content.style.display = 'none';
            });
            const targetId = this.getAttribute('data-target');
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        targetContent.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            } else {
                document.getElementById('defaultContent').style.display = 'block';
            }
        });
    });

    const doorbellOptionsLinks = document.querySelectorAll('.doorbell-options a');
    doorbellOptionsLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const doorbellSection = document.getElementById('doorbell-info');
            if (doorbellSection) {
                doorbellSection.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        doorbellSection.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            document.querySelectorAll('#doorbellResetContent > div').forEach(content => {
                content.style.display = 'none';
            });
            const targetId = this.getAttribute('data-target');
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        targetContent.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            } else {
                document.getElementById('doorbellDefaultContent').style.display = 'block';
            }
        });
    });

    const floodlightOptionsLinks = document.querySelectorAll('.floodlight-options a');
    floodlightOptionsLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const floodlightSection = document.getElementById('floodlight-info');
            if (floodlightSection) {
                floodlightSection.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        floodlightSection.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            document.querySelectorAll('#floodlightResetContent > div').forEach(content => {
                content.style.display = 'none';
            });
            const targetId = this.getAttribute('data-target');
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        targetContent.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            } else {
                document.getElementById('floodlightDefaultContent').style.display = 'block';
            }
        });
    });

    const ipOptionsLinks = document.querySelectorAll('.ip-options a');
    ipOptionsLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const ipSection = document.getElementById('ip-info');
            if (ipSection) {
                ipSection.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        ipSection.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            document.querySelectorAll('#ipResetContent > div').forEach(content => {
                content.style.display = 'none';
            });
            const targetId = this.getAttribute('data-target');
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        targetContent.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            } else {
                document.getElementById('ipDefaultContent').style.display = 'block';
            }
        });
    });

    const batteryOptionsLinks = document.querySelectorAll('.battery-options a');
    batteryOptionsLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const batterySection = document.getElementById('battery-info');
            if (batterySection) {
                batterySection.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        batterySection.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            document.querySelectorAll('#batteryResetContent > div').forEach(content => {
                content.style.display = 'none';
            });
            const targetId = this.getAttribute('data-target');
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.style.display = 'block';
                if (isMobile()) {
                    setTimeout(() => {
                        targetContent.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            } else {
                document.getElementById('batteryDefaultContent').style.display = 'block';
            }
        });
    });
});
